<div class="cards">
    <div class="logo-container">
        <img class="logo" [src]="logo">
    </div>
    <div class="card d-flex" id="card-container">
        <form [formGroup]="resetForm" (ngSubmit)="submitForm()" *ngIf="!success" class="d-flex flex-column align-items-center" style="flex: 1;">
            <div class="d-flex justify-content-between" style="color: #1B9BBB; font-family:Arial, Helvetica, sans-serif; align-self: flex-start;">
                <a class="p-2" > {{'Reset Password' | translate}}</a>
                <div class="p-2 language">
                    <a class="language-btn" > 
                        <i class="icon-translate"></i>
                        <p>{{ 'Language' | translate }}</p>
                    </a>
                    <div class="language-body">
                        <ul class="list-group">
                            <li class="list-group-item">
                                <a (click)="useLanguage('en')">
                                    <p>English</p>
                                </a>
                            </li>
                            <li class="list-group-item">
                                <a (click)="useLanguage('jp')">
                                    <p>日本語</p>
                                </a>
                            </li>
                            <li *ngIf="!isSuntory" class="list-group-item">
                                <a (click)="useLanguage('de')">
                                    <p>Deutsch</p>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="form-group mt-3 w-100">
                <div class="d-flex flex-column" style="color: grey">
                    <div class="d-flex align-items-center" [class.is-met]="!newPassword?.errors?.required && !newPassword.errors?.minlength">
                        <input [ngModel]="!newPassword?.errors?.required && !newPassword.errors?.minlength" (click)="$event.preventDefault()" [ngModelOptions]="{standalone: true}" type="checkbox">
                        <label class="ml-2 mb-0">{{ 'Minimum 8 characters' | translate }}</label>
                    </div>
                    <div class="d-flex align-items-center" [class.is-met]="!newPassword?.errors?.required && !newPassword.errors?.lowerRequired">
                        <input [ngModel]="(!newPassword?.errors?.required && !newPassword.errors?.lowerRequired)" [ngModelOptions]="{standalone: true}" (click)="$event.preventDefault()" type="checkbox">
                        <label class="ml-2 mb-0">{{ 'At least one (1) lowercase letter' | translate }}</label>
                    </div>
                    <div class="d-flex align-items-center" [class.is-met]="!newPassword?.errors?.required && !newPassword.errors?.upperRequired">
                        <input [ngModel]="(!newPassword?.errors?.required && !newPassword.errors?.upperRequired)" [ngModelOptions]="{standalone: true}" (click)="$event.preventDefault()" type="checkbox">
                        <label class="ml-2 mb-0">{{ 'At least one (1) uppercase letter' | translate }}</label>
                    </div>
                    <div class="d-flex align-items-center" [class.is-met]="!newPassword?.errors?.required && !newPassword.errors?.numberRequired">
                        <input [ngModel]="(!newPassword?.errors?.required && !newPassword.errors?.numberRequired)" [ngModelOptions]="{standalone: true}" (click)="$event.preventDefault()" type="checkbox">
                        <label class="ml-2 mb-0">{{ 'At least one (1) number' | translate }}</label>
                    </div>
                    <div class="d-flex align-items-center" [class.is-met]="!newPassword?.errors?.required && !newPassword.errors?.specialRequired">
                        <input [ngModel]="(!newPassword?.errors?.required && !newPassword.errors?.specialRequired)" [ngModelOptions]="{standalone: true}" (click)="$event.preventDefault()" type="checkbox">
                        <label class="ml-2 mb-0">{{ 'At least one (1) special character (eg: !@#$%^&*)' | translate }}</label>
                    </div>
                </div>
                <input [class.is-invalid]="newPassword.invalid && (newPassword.dirty || newPassword.touched)"
                    formControlName="newPassword"
                    style="background-color: #ececec; border-style: hidden; font-size: 15px; text-align: center;"
                    class="form-control form-control-lg mt-3" type="password" name="password" size="30"
                    placeholder="{{ 'new password' | translate }}">

                <div *ngIf="newPassword.invalid && newPassword.dirty" style="position: absolute" class="d-flex flex-column mt-2">
                    <small *ngIf="newPassword.errors?.required && newPassword.touched"
                        class="text-danger">{{ 'Password is required' | translate }}</small>
                </div>
            </div>
            <div [hidden]="newPassword.invalid" class="form-group w-100" style="margin-bottom: 2em;">
                <input
                    [class.is-invalid]="checkPassword.invalid && (checkPassword.dirty || checkPassword.touched)"
                    formControlName="checkPassword"
                    style="background-color: #ececec; border-style: hidden; font-size: 15px; text-align: center;"
                    class="form-control form-control-lg" type="password" name="password" size="30"
                    placeholder="{{'confirm new password' | translate}}">

                <div *ngIf="checkPassword.invalid" class="d-flex flex-column mt-2" style="position: absolute">
                    <small *ngIf="checkPassword.errors?.required && checkPassword.touched"
                        class="text-danger">{{ 'Re-enter password' | translate }}</small>
                    <!-- <small *ngIf="checkPassword.errors?.minlength"
                        class="text-danger">{{ 'Password is too short! Minimum 8 characters' | translate }}</small> -->
                    <small *ngIf="checkPassword.errors?.sameAsFirst"
                        class="text-danger">{{ 'Password has to be the same as above' | translate }}</small>
                </div>
            </div>
            <div class="d-flex justify-content-between align-items-end" style="flex: 1;">
                <button class="btn btn-md btn-primary" style="width: 150px; height: 44px" type="submit" [disabled]="resetForm.invalid"
                    (click)="submitClicked">{{ 'Go!' | translate }}</button>
            </div>
        </form>
        <div class="d-flex flex-column justify-content-center align-items-center" style="flex: 1;" *ngIf="success">
            <span style="color: #1B9BBB">{{ 'Password has been reset, proceed to login page.' | translate }}</span>
            <br />
            <br />
            <button class="btn btn-md btn-primary" style="width: 150px; height: 44px;" type="submit"
                (click)="loginpage()">{{ 'Go!' | translate }}</button>
        </div>
    </div>
</div>